var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlemdag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.8,3.1c-.3.5-1.7,9-1.4,9.5,1.9,3.2,1,6.8,1.8,10.1.3,1.2.5,2.4-1.3,2.4-.2,0-.5.2-.6.4-.5,2.9-4.1,4.4-3.7,7.7,0,.3-.1.7-.3,1-.1.3-.2.7-.7.7-.4,0-.3-.5-.4-.7-1.3-2.2-2.4-4.6-4.4-6.4-.4-.4-.8-.7-1.4-.8-.3-2-1.7-3.2-3.1-4.5-3.4-3-5.5-6.7-6.6-11.1-.3-1.3-1.5-2-1.9-3.2,1.1-.3,2-.9,2.7-1.6,3-2.9,6.8-3.9,10.7-4.5,2.1-.3,4-1.6,6.2-1.8,1.4-.2,2.9-.2,4.3-.4,1.2-.1,1.1.4.7,1.1-.3.7-.6,1.3-.9,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlemdag);
export default __webpack_public_path__ + "static/media/alemdag.d6f8a2acaadbe1e8016155dadabcab66.svg";
export { ForwardRef as ReactComponent };